import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const UserTableHead = enhance(({ order, orderBy, onRequestSort, roles }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell />
        <TableCell sortDirection={orderBy === 'childFoodId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'childFoodId'}
            direction={order}
            onClick={() => {
              onRequestSort('childFoodId');
            }}
          >
            メニューID
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'childFoodName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'childFoodName'}
            direction={order}
            onClick={() => {
              onRequestSort('childFoodName');
            }}
          >
            メニュー名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'shop.shopName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shop.shopName'}
            direction={order}
            onClick={() => {
              onRequestSort('shop.shopName');
            }}
          >
            店舗名
          </TableSortLabel>
        </TableCell>
        {(roles.isSecretariat || roles.isCreateChildFoodShop) && (
          <TableCell
            sortDirection={orderBy === 'group.groupName' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'group.groupName'}
              direction={order}
              onClick={() => {
                onRequestSort('group.groupName');
              }}
            >
              運営会社名
            </TableSortLabel>
          </TableCell>
        )}
        <TableCell
          sortDirection={orderBy === 'group.menu.menuId' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'group.menu.menuId'}
            direction={order}
            onClick={() => {
              onRequestSort('group.menu.menuId');
            }}
          >
            該当のお食事券
          </TableSortLabel>
        </TableCell>
        <TableCell />
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(UserTableHead);
